// @ts-check
/// <reference path="../../types/index.js" />

import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import { ExitToApp, Lock } from '@material-ui/icons';
import ListItemText from '@mui/material/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import { releaseLockedProcess } from '../../util/Rest';
import { ListItem, ListItemIcon } from '@mui/material';
import { resetRoleData } from '../../redux/reducers/role';
import { resetWorkQueue, resetStatusWorkQueueList } from '../../redux/reducers/WorkQueue';

const CmtDropdownMenu = ({ TriggerComponent }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();
  const dispatch = useDispatch();
  /**
   * Selects role data from the Redux state.
   * @param {ReduxState} state - The Redux state.
   * @return {RoleData} - The role data.
   */
  const selectRoleData = ({ role }) => role;
  const { roleData } = useSelector(selectRoleData);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleResetPasswordClick = () => {
    const previousUrl = window.location.href;
    const urlInstance = new URL(previousUrl);
    const onlyPath = urlInstance.pathname;
    localStorage.setItem('previousUrl', onlyPath);
    history.push('/change-password');
  };

  const handleLogoutClick = () => {
    releaseLockedProcess();
    sessionStorage.clear();
    history.push('/login');
    dispatch(resetRoleData());
    dispatch(resetWorkQueue());
    dispatch(resetStatusWorkQueueList());
  };

  return (
    <React.Fragment>
      <Box className="pointer">
        <TriggerComponent.type {...TriggerComponent.props} onClick={openMenu} />
      </Box>
      <Menu
        sx={{
          my: '0 !important',
          py: '0 !important',
          '& .MuiMenu-list': {
            padding: '0',
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ListItem tabIndex={-1}>
          <ListItemText sx={{ textTransform: 'uppercase' }}>
            <strong>{roleData?.userDetails?.role}</strong>
          </ListItemText>
        </ListItem>
        <Divider sx={{ my: '0 !important', py: 0 }} />
        <MenuItem
          onClick={handleResetPasswordClick}
          sx={{
            py: 1,
          }}
        >
          <ListItemIcon sx={{ minWidth: '30px' }}>
            <Lock />
          </ListItemIcon>
          <ListItemText>{'Reset Password'}</ListItemText>
        </MenuItem>
        <Divider sx={{ my: '0 !important', py: 0 }} />
        <MenuItem
          onClick={handleLogoutClick}
          sx={{
            py: 1,
          }}
        >
          <ListItemIcon sx={{ minWidth: '30px' }}>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText>{'Logout'}</ListItemText>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

CmtDropdownMenu.propTypes = {
  TriggerComponent: PropTypes.element.isRequired,
};

export default CmtDropdownMenu;
